var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "row mb-3" },
        [
          _c("search-bar", {
            attrs: { placeholder: "Nach Namen suchen ..." },
            model: {
              value: _vm.searchString,
              callback: function($$v) {
                _vm.searchString = $$v
              },
              expression: "searchString"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasNoData ? _c("no-data") : _vm._e(),
      _vm._v(" "),
      !_vm.hasNoData && _vm.isLoading ? _c("loader") : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.filteredList, function(item, index) {
        return !_vm.isLoading
          ? _c("brand", {
              key: item.id,
              attrs: { "data-index": index, item: item }
            })
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }